import {gql} from 'apollo-angular';

export const GET_SCHOOL_CLASSES_BY_USER = gql`
  query GetSchoolClasses {
    getSchoolClassesByUser {
      id
      name
      numberStudents

      grade {
        id
        name
      }

      classCode
      teachers {
        id
      }

      school {
        name
      }

      classNumber
      classAddition

      schoolClassRankMin {
        points
        playtimeMinutes
        rank
        activityLevel
      }

      trophyStats {
        totalCount
        scoredCount
      }
      milestoneStats {
        totalCount
        scoredCount
      }

    }
  }
`;
